// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import forEach from 'lodash/forEach'
import moment from 'moment'
import { i18n } from '../index'
import { PRODUCT_GROUPS } from './CustomerTargetPage'
import type { DailySales, GroupedCustomerTargets } from './customerTargetTypes'

export const getProductGroupLabel = (subject: string): string => {
  return i18n.t(`productGroup.label.${subject}`)
}

export const getTableData = (customerTargets: GroupedCustomerTargets, dailySales: DailySales[], week: string) => {
  const data = []

  PRODUCT_GROUPS.forEach((productGroup) => {
    const rowData = {
      productGroup: productGroup,
      data: [],
    }

    const date = moment(week).startOf('week')
    for (let i = 0; i < 7; ++i) {
      if (i > 0) {
        date.add(1, 'days')
      }

      let customerTarget = null
      forEach(customerTargets[productGroup], (item) => {
        if (item.productType === productGroup && item.date === date.format('YYYY-MM-DD')) {
          customerTarget = item
          return false
        }
      })

      rowData.data.push({
        calculatedValue:
          customerTarget && customerTarget.calculatedTarget ? String(customerTarget.calculatedTarget) : '0',
        value: customerTarget && customerTarget.target ? String(customerTarget.target) : '',
      })
    }

    data.push(rowData)
  })

  return data
}

export const getProductGroupName = (productGroup: string): string => {
  switch (productGroup) {
    case 'AbcPizzaTable':
      return 'Pizzatable'
    case 'AbcBuffetWorld':
      return 'BuffetWorld'
    default:
      return productGroup
  }
}
